
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members-festival",
      function () {
        return require("private-next-pages/members-festival/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members-festival"])
      });
    }
  